// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2c-1";
export var rateTableServiceLevelDropdown = "_2c-3";
export var rateTableTypeDropdown = "_2c-0";
export var rateTableValueModeDropdown = "_2c-2";